export const policyOptions = [
  { label: "Others (Staff)", value: "Others (Staff)", userType: "Others" },
  { label: "MInister_100M_365D", value: "MInister_100M_365D", userType: "Minister" },
  { label: "Secretary_100M_365D", value: "Secretary_100M_365D", userType: "Secretary" },
  { label: "Director_100M_365D", value: "Director_100M_365D", userType: "Director" },
];
